import Vue from 'vue'
export default {
  namespaced: true,
  state:
  {
    promociones: [],
    descuentos: [],
    pedidosHome: [],
    categorias: [],
    subcategorias: [],
    productos: [],
    imagenes: [],
    goTo:'',

    carrito:     JSON.parse(localStorage.getItem('carrito') || '[]'),
    pedidoId:    localStorage.getItem('pedidoId')   || -1,
    borradorId:  localStorage.getItem('borradorId') || 0,
    seleccion:   localStorage.getItem('seleccion')  || 0,
    deposito:    JSON.parse(localStorage.getItem('deposito') || null),
    idMoneda:    localStorage.getItem('idMoneda')  || 1
  },


 getters: {
    getPromoHome: state => {
       return state.promociones.slice(0, 3)
    },
  },


  mutations: 
  {
    saveDeposito (state, deposito) {
      state.deposito = deposito
      localStorage.setItem("deposito",JSON.stringify(deposito));
    },

    saveMoneda (state, idMoneda) {
      state.idMoneda = idMoneda
      localStorage.setItem("idMoneda",idMoneda);
    },

    savePromociones (state, p) {
      state.promociones = p
    },

    saveCategorias (state, categorias) {
      state.categorias = categorias
    },

    saveSubcategorias (state, subcategorias) {
      state.subcategorias = subcategorias
    },

    saveProductos (state, productos) {
      state.productos = productos
    },

    agregarAPedido (state, producto) {
      state.carrito.push(producto)
      localStorage.setItem("carrito",JSON.stringify(state.carrito));
    },

    replicarPedido (state, pedido) {
      console.log(pedido)
      state.carrito = pedido
    },

    eliminarPedido (state) {
      state.carrito = []
      state.borradorId = 0
      localStorage.removeItem("carrito");
      localStorage.removeItem("borradorId");
    },

    eliminarProductos (state) {
      state.productos = []
    },

    eliminarDeposito (state) {
      state.deposito = null
      localStorage.removeItem("deposito");
    },

    eliminarItemPedido (state, id) {
      var ind = state.carrito.map((el) => el.id).indexOf(id)
      if (ind > -1) {
        Vue.delete(state.carrito, ind)
        localStorage.setItem("carrito",JSON.stringify(state.carrito));
      }
    },

    updateItemCarrito (state, item) {
      var ind = state.carrito.map((el) => el.id).indexOf(item.id)
      if (ind > -1) {
        Vue.set(state.carrito, ind, item)
      }
    },

    savePedidoId (state, id) {
      state.pedidoId = id
      localStorage.setItem("pedidoId",id);
    },

    saveSucursales (state, sucursales) {
      state.sucursales = sucursales
    },

    setBorradorId (state, id) {
      state.borradorId = id
      localStorage.setItem("borradorId",id);
    },

    setSeleccion (state, selec) {
      state.seleccion = selec
      localStorage.setItem("seleccion",selec);
    },

    saveImage (state, img) {
      state.imagenes.push(img)
    },

    saveGoTo (state, gt) {
      state.goTo = gt
    },

    delete (state) {
      state.promociones   = []
      state.descuentos    = []
      state.pedidosHome   = []
      state.categorias    = []
      state.subcategorias = []
      state.productos     = []
      state.carrito       = []
      state.pedidoId      = -1
      state.borradorId    = 0
      state.seleccion     = 0
      state.imagenes      = []
      state.deposito      = null
      state.idMoneda      = 1

      localStorage.removeItem("carrito");
      localStorage.removeItem("borradorId");
      localStorage.removeItem("seleccion");
      localStorage.removeItem("pedidoId");
      localStorage.removeItem("deposito");
      localStorage.removeItem("idMoneda");
    },

  }

}



// WEBPACK FOOTER //
// ./src/store/modules/pedido.js